import { useNavigate } from 'react-router-dom'
import { useAppSelector } from '../../store/hooks'
import NavBack from '../base/NavBack'
import AssignmentManager from './AssignmentManager'
import styles from './ManageTeam.module.css'

export default function ManageTeam() {
  const navigate = useNavigate()
  const profile = useAppSelector((s) => s.auth.profile)
  const canManage = profile?.app_role === 'admin' || profile?.app_role === 'leader'

  if (!canManage) {
    return (
      <div className={styles.page} data-testid="manage-access-denied">
        <NavBack label="Dashboard" onClick={() => navigate('/')} />
        <p>Access denied. Leader or admin role required.</p>
      </div>
    )
  }

  return (
    <div className={styles.page} data-testid="manage-team-page">
      <NavBack label="Dashboard" onClick={() => navigate('/')} />
      <h1 className={styles.title}>Manage Team</h1>
      <AssignmentManager />
    </div>
  )
}
